import { ErrorBlock } from '@/components/common/ErrorBlock'
import { PreconCard } from '@/components/common/PreconCard'
import { usePage } from '@/components/providers/PageProvider'
import { type StatType } from '@/defs/stat'
import { cn } from '@/utils/commonUtil'

import styles from './FeaturedRecPrecon.module.scss'

type Props = {
  stats?: StatType[]
}

export const FeaturedRecPrecon = ({ stats }: Props) => {
  const { page } = usePage()
  const rec = page?.featured?.rec
  const { image } = page?.featured?.precon || {}

  if (!rec) return <ErrorBlock />

  return (
    <div className={cn(styles.container, { hasImage: !!image, styles })}>
      <PreconCard image={image} rec={rec} stats={stats} />
    </div>
  )
}
